import { ApolloClient, createHttpLink, InMemoryCache, ApolloLink } from '@apollo/client/core'
import { removeTypenameFromVariables } from '@apollo/client/link/remove-typename'

export const createApolloClient = (baseUrl: string, authHeaders?: Record<string, string>) => {
  const httpLink = createHttpLink({
    uri: baseUrl
  })

  const authMiddleware = new ApolloLink((operation, forward) => {
    operation.setContext({
      headers: authHeaders
    })
    return forward(operation)
  })

  const removeTypenameLink = removeTypenameFromVariables()
  const link = ApolloLink.from([authMiddleware, removeTypenameLink, httpLink])

  return new ApolloClient({
    link,
    cache: new InMemoryCache()
  })
}
